import * as Sentry from '@sentry/vue'
import type { App } from 'vue'

export const createSentry = (app: App) => {
    if (!import.meta.env.VITE_SENTRY_DSN) return
    Sentry.init({
        app,
        dsn:         import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.VITE_ENVIRONMENT || 'dev',
    })
}
